"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  version: 0,
  completeEventsExpiryDays: 0,
  expiryDays: 0
};
exports.default = _default;
//# sourceMappingURL=program.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/model/config/model-defaults/program.js
// module id = 1238
// module chunks = 0